import { Form, Modal } from 'antd';
import React from 'react';
import AllowedPlansTable from '../../components/AllowedPlansTable';

const AssignPlanModal = ({
  open,
  onClose,
  selectedPlanKey,
  selectedIds,
  bulkEditMutatuion,
  submitLoading
}) => {
  const [form] = Form.useForm();

  const handleFormFinish = (values) => {
    const allowedPlans = values?.allowedPlans?.map((plan) => ({
      key: plan?.key?.value,
      expiredAt: plan?.expiredAt
    }));

    const whereToAdd =
      selectedPlanKey?.length > 0
        ? { allowedPlans: selectedPlanKey }
        : { ids: selectedIds };

    const payload = {
      where: {
        ...whereToAdd
      },
      data: {
        allowedPlans
      }
    };

    bulkEditMutatuion({
      variables: payload
    });
  };
  return (
    <Modal
      open={open}
      title="Please select plan to assign"
      onCancel={onClose}
      centered
      destroyOnClose
      onOk={form.submit}
      width="680px"
      wrapClassName="assign-plan-modal"
    >
      <Form form={form} onFinish={handleFormFinish}>
        <fieldset className="mb-12">
          <legend className="role-legend">Allowed Plans</legend>
          <AllowedPlansTable
            loading={submitLoading}
            form={form}
            formKey="allowedPlans"
          />
        </fieldset>
      </Form>
    </Modal>
  );
};

export default AssignPlanModal;
